import { useTranslation } from "react-i18next";
import { FlexContext } from "../models/flexible/flex-context";
import { FlexFieldController } from "../models/flexible/flex-field-controller";
import { FlexSectionController } from "../models/flexible/flex-section-controller";
import { FlexSectionSchema } from "../models/flexible/flex-section-schema";

export class MedicalSummarySectionController implements FlexSectionController {
	context: FlexContext = {} as any;

	constructor(
		readonly schema: FlexSectionSchema,
		readonly path: string,
		readonly fieldControllers: Array<FlexFieldController>,
		readonly sectionControllers: Array<FlexSectionController>
	) {}

	useGetInfoMessage() {
		const { t } = useTranslation();
		return this.noNewAttributes ? t("no-new-negotiable-attributes") : undefined;
	}

	useIsSectionOpenByDefault() {
		return !this.noNewAttributes;
	}

	private get noNewAttributes() {
		return (
			this.fieldControllers.every((field) => field.schema.attribute.isDisabled) &&
			this.sectionControllers.every((section) => section.fieldControllers.every((field) => field.schema.attribute.isDisabled))
		);
	}
}
